import { Download, Mail } from 'lucide-react'

import { downloadCSV, getCSVString, toISO8601 } from '@fortem-monorepo/js-utilities'
import { HeaderConfigBar } from '@fortem-monorepo/react-spa'
import { Button, DatePickerWithControls, Label, LoadingButton, Switch } from '@fortem-monorepo/react-ui'

import { DISPLAY_TABS, useMarketSummaryContext } from '@/pages/instruments/market-summary/market-summary-context'
import { useEmailMarketSummaryMutation } from '@/pages/instruments/market-summary/market-summary.mutations'

export interface MarketSummaryReportControlsProps {}

export const MarketSummaryReportControls: React.FC<MarketSummaryReportControlsProps> = () => {
  const { value_date, setValueDate, reportQuery, view, displayTab } = useMarketSummaryContext()
  const emailMutation = useEmailMarketSummaryMutation()

  return (
    <HeaderConfigBar sticky>
      <div className="flex items-center gap-4">
        <div className="space-y-2">
          <DatePickerWithControls
            size="sm"
            placeholder={'Select a report date...'}
            selected={value_date}
            onSelect={(date) => (date ? setValueDate(date) : undefined)}
            todayButton={{ enabled: true }}
          />
        </div>
        <div className="flex items-center gap-2">
          <Label className={'text-muted-foreground'}>Force Month End</Label>
          <div className="h-8 flex items-center">
            <Switch />
          </div>
        </div>
        {displayTab === DISPLAY_TABS.REPORT && (
          <>
            <Button
              size="sm"
              variant="outline"
              disabled={!reportQuery.data || reportQuery.isFetching}
              onClick={() => {
                downloadCSV(
                  getCSVString(reportQuery.data?.block.rows ?? []),
                  `market-summary_${view?.display_name}_${toISO8601(value_date)}`,
                )
              }}
            >
              Export report as CSV <Download />
            </Button>
            <LoadingButton
              size="sm"
              variant="outline"
              icon={<Mail />}
              disabled={!view || !reportQuery.data || reportQuery.isFetching || emailMutation.isPending}
              onClick={async () => {
                if (!view || emailMutation.isPending) return
                // The mutation's onError displays delivery failures to the user.
                await emailMutation
                  .mutateAsync({ display_id: view.display_id, report_date: toISO8601(value_date) })
                  .catch(() => undefined)
              }}
            >
              {emailMutation.isPending ? 'Sending email...' : 'Email report to me'}
            </LoadingButton>
          </>
        )}
      </div>
    </HeaderConfigBar>
  )
}
